// extracted by mini-css-extract-plugin
export default {"fitContainer":"JM-z","label":"KM-z","selectField":"LM-z","select":"MM-z","disabled":"NM-z","archField":"OM-z"};